import { isCurrentView } from "./utils/view-util";

document.addEventListener("DOMContentLoaded", function () {
  if (!isCurrentView(".sbsa-portal")) {
    return;
  }

  // sidebar mobile nav toggle
  $('[data-toggle="offcanvas"]').on("click", function () {
    $('[data-toggle="offcanvas"]').toggleClass("is-active");
    $(".offcanvas-collapse").toggleClass("open");
    $(".navbar-backdrop").toggleClass("show");
  });
});

document.addEventListener("DOMContentLoaded", function () {
  if (!isCurrentView(".portal")) {
    return;
  }

  // SnapScan portal sidebar mobile nav toggle
  $('[data-toggle="offcanvas"]').on("click", function () {
    $('[data-toggle="offcanvas"]').toggleClass("is-active");
    $(".offcanvas-collapse").toggleClass("open");
    $(".navbar-backdrop").toggleClass("show");
  });
});
